import type { FormFieldDto } from '../../form.types';
import { FormChoiceTile } from './FormChoiceTile';
import { TILES_CLASS } from './field.styles';

interface FormFieldCheckboxProps {
    field: FormFieldDto;
}

export function FormFieldCheckbox({ field }: FormFieldCheckboxProps) {
    return (
        <div className={TILES_CLASS}>
            {field.choices?.map((choice) => (
                <FormChoiceTile
                    key={choice._key ?? choice.value}
                    choice={choice}
                    type="checkbox"
                    name={`${field.name}[]`}
                />
            ))}
        </div>
    );
}
